import useBreadcrumbs from './useBreadcrumbs';

export default useBreadcrumbs;
